import * as React from 'react'
import { RouteComponentProps } from 'react-router-dom'
import Modal from '../ui/Modal'
import SettingForm from './SettingFormik'

export default class AddMobilityCategoryModal extends React.Component<RouteComponentProps<any>> {
  public render() {
    return (
      <Modal>
        <div className='fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center font-black'>
          <div className='bg-white col-4 relative'>
            <SettingForm title='ADD MOBILITY CATEGORY' labelTitle='Mobility Category'>
              <button className='p1 font-grey h5 bg-white border-white mr1' onClick={this.onCancel}>
                Cancel
              </button>
              <button className='pt1 pb1 pl2 pr2 border-radius h5 bg-green border-green font-white' type='submit'>
                Add
              </button>
            </SettingForm>
          </div>
        </div>
      </Modal>
    )
  }

  private onCancel = () => {
    this.props.history.push('/global-settings/mobility-category')
  }
}



// WEBPACK FOOTER //
// ./src/components/global-settings/AddMobilityCategoryModal.tsx